import { Cross, ArrowLeft, FileText, CheckCircle, Smartphone, Ban, Megaphone, Copyright, Link2, Bot, AlertTriangle, ShieldX, Scale, Settings, Gavel, FileCheck, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]" data-testid="terms-of-use-page">
      {/* Header */}
      <header className="bg-[#1C1917] text-white py-6 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center gap-2 text-[#D4AF37] hover:text-[#F4D03F] transition-colors"
            data-testid="back-home-link"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Voltar ao início</span>
          </Link>
          <div className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_ade5b22e-2078-466a-8931-f51bba223cfa/artifacts/3wtm88gi_logo-tema-claro-atualizado.png"
              alt="Santo Universo"
              className="w-8 h-8"
            />
            <span className="font-serif font-semibold">Santo Universo</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        {/* Title Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF37]/10 mb-6">
            <FileText className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1C1917] mb-4">
            Termos de Uso
          </h1>
          <p className="text-[#57534E]">
            Santo Universo - Aplicativo Católico
          </p>
          <p className="text-sm text-[#A8A29E] mt-2">
            Última atualização: 07 de Fevereiro de 2026
          </p>
        </div>

        {/* Terms Content */}
        <div className="prose prose-lg max-w-none">
          
          {/* Section 1 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">1</span>
              <CheckCircle className="w-6 h-6 text-[#D4AF37]" />
              Aceitação dos Termos
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              Ao baixar, instalar ou utilizar o aplicativo Santo Universo ("Aplicativo"), você concorda em ficar vinculado a estes Termos de Uso ("Termos"). <strong>Se você não concordar com qualquer parte destes Termos, não deverá utilizar o Aplicativo.</strong>
            </p>
            <p className="text-[#57534E] leading-relaxed">
              Estes Termos constituem um acordo legal entre você ("Usuário") e o Santo Universo ("nós", "nosso" ou "Aplicativo"). Reservamo-nos o direito de modificar estes Termos a qualquer momento, sendo sua responsabilidade revisá-los periodicamente.
            </p>
          </section>

          {/* Section 2 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">2</span>
              <Smartphone className="w-6 h-6 text-[#D4AF37]" />
              Descrição do Serviço
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              O Santo Universo é um aplicativo católico gratuito que oferece:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Bíblia Sagrada completa</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Liturgia Diária e Calendário Litúrgico</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Santo do Dia</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Orações e Devoções</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Catecismo da Igreja Católica</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Terço e Meditações</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Músicas Católicas</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Conteúdos em vídeo (Café com Cristo, Pílulas de Fé)</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Notícias da Igreja</span>
              </div>
              <div className="bg-[#F5F2EB] p-3 rounded-lg flex items-center gap-2">
                <Cross className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[#57534E]">Direção Espiritual com Inteligência Artificial</span>
              </div>
            </div>
            <p className="text-[#57534E] mt-4 italic">
              O Aplicativo é disponibilizado gratuitamente e é sustentado por publicidade.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">3</span>
              Elegibilidade
            </h2>
            <p className="text-[#57534E] leading-relaxed">
              O Santo Universo está disponível para usuários de todas as idades. Menores de 18 anos devem ter autorização dos pais ou responsáveis legais para utilizar o Aplicativo. Ao utilizar o Aplicativo, você declara que possui capacidade legal para celebrar este acordo ou que obteve o consentimento necessário de seus responsáveis.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">4</span>
              <FileCheck className="w-6 h-6 text-[#D4AF37]" />
              Licença de Uso
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              Concedemos a você uma licença limitada, não exclusiva, intransferível e revogável para:
            </p>
            <ul className="list-disc list-inside text-[#57534E] space-y-2 mb-4">
              <li>Baixar e instalar o Aplicativo em dispositivos de sua propriedade</li>
              <li>Utilizar o Aplicativo para fins pessoais e não comerciais</li>
              <li>Acessar os conteúdos disponibilizados no Aplicativo</li>
            </ul>
            <p className="text-[#800020] font-semibold">
              Esta licença não inclui o direito de modificar, distribuir, vender, alugar ou criar obras derivadas do Aplicativo ou de seu conteúdo.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-10 p-6 bg-[#800020]/5 rounded-2xl border border-[#800020]/20">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#800020] text-white flex items-center justify-center text-sm font-bold">5</span>
              <Ban className="w-6 h-6 text-[#800020]" />
              Conduta do Usuário
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              Ao utilizar o Aplicativo, você concorda em <strong>NÃO</strong>:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Violar qualquer lei ou regulamento aplicável</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Utilizar o Aplicativo para fins ilegais ou não autorizados</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Tentar acessar áreas restritas sem autorização</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Interferir ou interromper o funcionamento do Aplicativo</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Copiar, modificar ou distribuir o conteúdo sem permissão</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Utilizar robôs, spiders ou meios automatizados</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Remover avisos de direitos autorais ou propriedade</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#57534E]">Utilizar o Aplicativo para enviar spam ou conteúdo malicioso</span>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">6</span>
              <Megaphone className="w-6 h-6 text-[#D4AF37]" />
              Publicidade
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              O Santo Universo é um aplicativo gratuito sustentado por publicidade. Ao utilizar o Aplicativo, você concorda em visualizar anúncios exibidos por nossos parceiros publicitários, incluindo, mas não se limitando a:
            </p>
            <div className="bg-[#F5F2EB] p-4 rounded-xl mb-4">
              <ul className="text-[#57534E] space-y-2">
                <li>• <strong>Google AdMob</strong></li>
                <li>• <strong>Amazon Ads</strong></li>
                <li>• <strong>Mercado Livre Ads</strong></li>
                <li>• <strong>Shopee Ads</strong></li>
                <li>• Outras redes de publicidade programática</li>
              </ul>
            </div>
            <p className="text-[#57534E] italic">
              Os anúncios podem ser personalizados com base em seus interesses e comportamento de navegação. Você pode gerenciar suas preferências de anúncios nas configurações do seu dispositivo.
            </p>
          </section>

          {/* Section 7 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">7</span>
              <Copyright className="w-6 h-6 text-[#D4AF37]" />
              Propriedade Intelectual
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              Todo o conteúdo do Aplicativo, incluindo mas não se limitando a textos, gráficos, logotipos, ícones, imagens, clipes de áudio, compilações de dados e software, é de propriedade do Santo Universo ou de seus licenciadores e é protegido pelas leis brasileiras e internacionais de direitos autorais.
            </p>
            <p className="text-[#57534E] leading-relaxed">
              Os textos bíblicos, litúrgicos e do Catecismo são de domínio público ou utilizados com as devidas autorizações eclesiásticas.
            </p>
          </section>

          {/* Section 8 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">8</span>
              <Link2 className="w-6 h-6 text-[#D4AF37]" />
              Conteúdo de Terceiros
            </h2>
            <p className="text-[#57534E] leading-relaxed">
              O Aplicativo pode conter links para sites de terceiros, vídeos do YouTube e outros conteúdos externos. Não nos responsabilizamos pelo conteúdo, políticas de privacidade ou práticas de sites ou serviços de terceiros. O acesso a esses conteúdos é de sua inteira responsabilidade.
            </p>
          </section>

          {/* Section 9 - AI Warning */}
          <section className="mb-10 p-6 bg-[#FEF3C7] rounded-2xl border-2 border-[#F59E0B]">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#F59E0B] text-white flex items-center justify-center text-sm font-bold">9</span>
              <Bot className="w-6 h-6 text-[#F59E0B]" />
              Direção Espiritual com IA
            </h2>
            
            <div className="bg-white p-4 rounded-xl mb-4 flex items-start gap-3 border border-[#F59E0B]">
              <AlertTriangle className="w-6 h-6 text-[#F59E0B] flex-shrink-0 mt-1" />
              <p className="text-[#800020] font-bold">⚠️ Aviso Importante</p>
            </div>

            <p className="text-[#57534E] leading-relaxed mb-4">
              A funcionalidade de "Direção Espiritual" utiliza Inteligência Artificial para fornecer orientações baseadas nos ensinamentos da Igreja Católica. No entanto, é fundamental compreender que:
            </p>

            <div className="space-y-3 mb-4">
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#F59E0B]">
                <span className="text-[#57534E]">A orientação por IA <strong>NÃO substitui</strong> a direção espiritual presencial com um sacerdote</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#F59E0B]">
                <span className="text-[#57534E]">A orientação por IA <strong>NÃO substitui</strong> o Sacramento da Confissão</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#F59E0B]">
                <span className="text-[#57534E]">A orientação por IA <strong>NÃO substitui</strong> aconselhamento profissional (psicológico, médico, etc.)</span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#F59E0B]">
                <span className="text-[#57534E]">As respostas são geradas automaticamente e <strong>podem conter imprecisões</strong></span>
              </div>
              <div className="bg-white p-3 rounded-lg border-l-4 border-[#800020]">
                <span className="text-[#800020] font-semibold">Em casos de emergência, procure ajuda profissional imediatamente</span>
              </div>
            </div>

            <p className="text-[#57534E] italic">
              Esta funcionalidade é oferecida apenas como ferramenta auxiliar de reflexão e edificação espiritual. O uso é limitado a 3 consultas diárias por usuário.
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">10</span>
              <ShieldX className="w-6 h-6 text-[#D4AF37]" />
              Isenção de Garantias
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              O Aplicativo é fornecido "como está" e "conforme disponível", sem garantias de qualquer tipo, expressas ou implícitas. Não garantimos que:
            </p>
            <ul className="list-disc list-inside text-[#57534E] space-y-2">
              <li>O Aplicativo funcionará de forma ininterrupta ou livre de erros</li>
              <li>Os defeitos serão corrigidos</li>
              <li>O Aplicativo ou o servidor que o disponibiliza estão livres de vírus</li>
              <li>Os resultados obtidos com o uso do Aplicativo serão precisos ou confiáveis</li>
            </ul>
          </section>

          {/* Section 11 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">11</span>
              <Scale className="w-6 h-6 text-[#D4AF37]" />
              Limitação de Responsabilidade
            </h2>
            <p className="text-[#57534E] leading-relaxed mb-4">
              Em nenhuma circunstância o Santo Universo, seus diretores, funcionários, parceiros ou afiliados serão responsáveis por quaisquer danos diretos, indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes de:
            </p>
            <ul className="list-disc list-inside text-[#57534E] space-y-2">
              <li>Uso ou incapacidade de usar o Aplicativo</li>
              <li>Qualquer conteúdo obtido através do Aplicativo</li>
              <li>Acesso não autorizado ou alteração de suas transmissões ou dados</li>
              <li>Declarações ou conduta de terceiros no Aplicativo</li>
              <li>Qualquer outro assunto relacionado ao Aplicativo</li>
            </ul>
          </section>

          {/* Section 12 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">12</span>
              <Settings className="w-6 h-6 text-[#D4AF37]" />
              Modificações do Aplicativo
            </h2>
            <p className="text-[#57534E] leading-relaxed">
              Reservamo-nos o direito de modificar, suspender ou descontinuar o Aplicativo (ou qualquer parte dele) a qualquer momento, com ou sem aviso prévio. Não seremos responsáveis perante você ou terceiros por qualquer modificação, suspensão ou descontinuação do Aplicativo.
            </p>
          </section>

          {/* Section 13 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">13</span>
              Rescisão
            </h2>
            <p className="text-[#57534E] leading-relaxed">
              Podemos rescindir ou suspender seu acesso ao Aplicativo imediatamente, sem aviso prévio ou responsabilidade, por qualquer motivo, incluindo, sem limitação, se você violar estes Termos. Após a rescisão, seu direito de usar o Aplicativo cessará imediatamente.
            </p>
          </section>

          {/* Section 14 */}
          <section className="mb-10 p-6 bg-white rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">14</span>
              <Gavel className="w-6 h-6 text-[#D4AF37]" />
              Lei Aplicável e Foro
            </h2>
            <p className="text-[#57534E] leading-relaxed">
              Estes Termos serão regidos e interpretados de acordo com as leis da <strong>República Federativa do Brasil</strong>, independentemente de conflitos de disposições legais. Você concorda em se submeter à jurisdição exclusiva dos tribunais localizados no Brasil para resolver qualquer disputa decorrente destes Termos.
            </p>
          </section>

          {/* Section 15 */}
          <section className="mb-10 p-6 bg-[#F5F2EB] rounded-2xl border border-[#D4AF37]/10">
            <h2 className="font-serif text-2xl font-bold text-[#1C1917] mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-white flex items-center justify-center text-sm font-bold">15</span>
              Disposições Gerais
            </h2>
            <div className="space-y-4">
              <div className="bg-white p-4 rounded-lg">
                <strong className="text-[#1C1917]">Acordo Integral:</strong>
                <span className="text-[#57534E]"> Estes Termos constituem o acordo integral entre você e o Santo Universo em relação ao uso do Aplicativo.</span>
              </div>
              <div className="bg-white p-4 rounded-lg">
                <strong className="text-[#1C1917]">Renúncia:</strong>
                <span className="text-[#57534E]"> A falha em exercer qualquer direito previsto nestes Termos não constituirá renúncia a tal direito.</span>
              </div>
              <div className="bg-white p-4 rounded-lg">
                <strong className="text-[#1C1917]">Divisibilidade:</strong>
                <span className="text-[#57534E]"> Se qualquer disposição destes Termos for considerada inválida, as demais disposições permanecerão em pleno vigor.</span>
              </div>
              <div className="bg-white p-4 rounded-lg">
                <strong className="text-[#1C1917]">Cessão:</strong>
                <span className="text-[#57534E]"> Você não pode ceder ou transferir seus direitos sob estes Termos sem nosso consentimento prévio por escrito.</span>
              </div>
            </div>
          </section>

          {/* Section 16 - Contact */}
          <section className="mb-10 p-6 bg-[#1C1917] rounded-2xl text-white">
            <h2 className="font-serif text-2xl font-bold mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#D4AF37] text-[#1C1917] flex items-center justify-center text-sm font-bold">16</span>
              <Mail className="w-6 h-6 text-[#D4AF37]" />
              Contato
            </h2>
            <p className="text-white/80 leading-relaxed mb-6">
              Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <div className="bg-white/10 p-4 rounded-xl">
              <p className="font-serif text-xl font-semibold text-[#D4AF37] mb-2">Santo Universo</p>
              <p className="text-white/90">
                <strong>E-mail:</strong> <a href="mailto:contato@universosaintapp.com.br" className="text-[#D4AF37] hover:underline">contato@universosaintapp.com.br</a>
              </p>
              <p className="text-white/90">
                <strong>Website:</strong> <a href="https://universosaintapp.com.br" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">universosaintapp.com.br</a>
              </p>
            </div>
          </section>

          {/* Final Note */}
          <div className="text-center p-6 bg-[#D4AF37]/10 rounded-2xl border border-[#D4AF37]/20">
            <p className="text-[#57534E] italic mb-4">
              Ao utilizar o aplicativo Santo Universo, você declara ter lido, compreendido e concordado com estes Termos de Uso.
            </p>
            <div className="flex items-center justify-center gap-2 text-[#D4AF37]">
              <Cross className="w-5 h-5" />
              <span className="font-serif font-semibold">© 2026 Santo Universo. Todos os direitos reservados.</span>
            </div>
          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1C1917] text-white py-6 px-6 mt-12">
        <div className="max-w-4xl mx-auto text-center">
          <Link to="/" className="text-[#D4AF37] hover:underline">
            ← Voltar para a página inicial
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfUse;
